import React from "react";
import { Box, VStack, Text, Spinner, HStack, IconButton } from "@chakra-ui/react";
import { Header } from "build-ts/metadata";
import AnalysisRunCardContainer from "../containers/AnalysisRunCard";
import { AppIcons } from "constants/icons";

interface AnalysisRunsViewerProps {
  isLoading: boolean;
  jobRuns: Header[];
  pageNumber: number;
  totalPages: number;
  onPrevPage: () => void;
  onNextPage: () => void;
  hideRunDetails?: boolean;
}

const AnalysisRunsViewer: React.FC<AnalysisRunsViewerProps> = ({
  isLoading,
  jobRuns,
  pageNumber,
  totalPages,
  onPrevPage,
  onNextPage,
  hideRunDetails = false,
}) => {
  if (isLoading) {
    return (
      <Box textAlign="center" py={8}>
        <Spinner size="lg" />
        <Text mt={4}>Loading analysis runs...</Text>
      </Box>
    );
  }

  return (
    <Box maxW="900px" mx="auto" w="100%" h="100%" display="flex" flexDirection="column">
      <Box flex="1" overflowY="auto">
        {jobRuns.length === 0 ? (
          <Text fontSize="xs" color="gray.400" textAlign="center" py={2}>
            No analysis runs found for this scheduled job.
          </Text>
        ) : (
          <VStack spacing={2} align="stretch">
            {jobRuns.map(jobRun => (
              <AnalysisRunCardContainer key={jobRun.id} jobRun={jobRun} hideRunDetails={hideRunDetails} />
            ))}
          </VStack>
        )}
      </Box>

      {totalPages > 1 && (
        <HStack
          justify="center"
          align="center"
          pt={3}
          mt={1}
          borderTop="1px solid"
          borderColor="gray.200"
          spacing={2}
          flexShrink={0}
        >
          <IconButton
            aria-label="Previous page"
            icon={<AppIcons.leftIcon boxSize={4} />}
            size="xs"
            variant="outline"
            isDisabled={pageNumber <= 1}
            onClick={onPrevPage}
          />
          <Text fontSize="sm" color="gray.600" mb={0} fontWeight="600">
            Page {pageNumber} of {totalPages}
          </Text>
          <IconButton
            aria-label="Next page"
            icon={<AppIcons.rightIcon boxSize={4} />}
            size="xs"
            variant="outline"
            isDisabled={pageNumber >= totalPages}
            onClick={onNextPage}
          />
        </HStack>
      )}
    </Box>
  );
};

export default AnalysisRunsViewer;
